import React from 'react';

const withForwardingRef = BaseComponent =>
  React.forwardRef((props, ref) => <BaseComponent {...props} forwardedRef={ref} />);

export default withForwardingRef;

// FYI! https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md
